import {
  ADD_LINE_ITEMS_FROM_UPLOAD_FAIL,
  ADD_LINE_ITEMS_FROM_UPLOAD_REQUEST,
  ADD_LINE_ITEMS_FROM_UPLOAD_SUCCESS,
  ADMIN_USER_ADD_FAIL,
  ADMIN_USER_ADD_REQUEST,
  ADMIN_USER_ADD_SUCCESS,
  ADMIN_USER_DELETE_FAIL,
  ADMIN_USER_DELETE_REQUEST,
  ADMIN_USER_DELETE_SUCCESS,
  ADMIN_USER_LIST_FAIL,
  ADMIN_USER_LIST_REQUEST,
  ADMIN_USER_LIST_SUCCESS,
  ADMIN_USER_UPDATE_FAIL,
  ADMIN_USER_UPDATE_REQUEST,
  ADMIN_USER_UPDATE_SUCCESS,
  APPROVE_ORDER_FAIL,
  APPROVE_ORDER_REQUEST,
  APPROVE_ORDER_RESET,
  APPROVE_ORDER_SUCCESS,
  ATTACHMENT_FILES_URL_FAIL,
  ATTACHMENT_FILES_URL_REQUEST,
  ATTACHMENT_FILES_URL_SUCCESS,
  AVAILABILITIES_FAIL,
  AVAILABILITIES_REQUEST,
  AVAILABILITIES_SUCCESS,
  BRANCH_ADD_FAIL,
  BRANCH_ADD_REQUEST,
  BRANCH_ADD_SUCCESS,
  BRANCH_DELETE_FAIL,
  BRANCH_DELETE_REQUEST,
  BRANCH_DELETE_SUCCESS,
  BRANCH_LIST_FAIL,
  BRANCH_LIST_REQUEST,
  BRANCH_LIST_SUCCESS,
  BRANCH_UPDATE_FAIL,
  BRANCH_UPDATE_REQUEST,
  BRANCH_UPDATE_SUCCESS,
  BULK_QUOTE_APPROVE_FAIL,
  BULK_QUOTE_APPROVE_REQUEST,
  BULK_QUOTE_APPROVE_RESET,
  BULK_QUOTE_APPROVE_SUCCESS,
  BULK_QUOTE_DELETE_FAIL,
  BULK_QUOTE_DELETE_REQUEST,
  BULK_QUOTE_DELETE_SUCCESS,
  BULK_QUOTE_RESET,
  CLEAR_EMAIL_CONVERSATIONS,
  CLEAR_HIGHLIGHT_COORDINATES,
  CLEAR_USER_BRANCH_AVAILABILITY_FAIL,
  CLEAR_USER_BRANCH_AVAILABILITY_REQUEST,
  CLEAR_USER_BRANCH_AVAILABILITY_SUCCESS,
  CREATE_QUOTATION_FAIL,
  CREATE_QUOTATION_REQUEST,
  CREATE_QUOTATION_RESET,
  CREATE_QUOTATION_SUCCESS,
  CREATE_QUOTE_FAIL,
  CREATE_QUOTE_REQUEST,
  CREATE_QUOTE_RESET,
  CREATE_QUOTE_SUCCESS,
  CUSTOMER_DETAILS_LIST_FAIL,
  CUSTOMER_DETAILS_LIST_REQUEST,
  CUSTOMER_DETAILS_LIST_RESET,
  CUSTOMER_DETAILS_LIST_SUCCESS,
  CUSTOMER_SHIPPING_DETAILS_FAIL,
  CUSTOMER_SHIPPING_DETAILS_REQUEST,
  CUSTOMER_SHIPPING_DETAILS_SUCCESS,
  DELETE_LINES_FAIL,
  DELETE_LINES_REQUEST,
  DELETE_LINES_SUCCESS,
  DELETE_ORDER_FAIL,
  DELETE_ORDER_REQUEST,
  DELETE_ORDER_SUCCESS,
  DISTRIBUTOR_LIST_FAIL,
  DISTRIBUTOR_LIST_REQUEST,
  DISTRIBUTOR_LIST_SUCCESS,
  EXISTING_ORDER_DETAILS_FAIL,
  EXISTING_ORDER_DETAILS_REQUEST,
  EXISTING_ORDER_DETAILS_SUCCESS,
  EXPAND_ROW_DETAILS_FAIL,
  EXPAND_ROW_DETAILS_REQUEST,
  EXPAND_ROW_DETAILS_SUCCESS,
  FETCH_CUSTOMER_PART_NUMBERS_FAILURE,
  FETCH_CUSTOMER_PART_NUMBERS_REQUEST,
  FETCH_CUSTOMER_PART_NUMBERS_SUCCESS,
  FETCH_FAVORITE_QUOTES_FAILURE,
  FETCH_FAVORITE_QUOTES_REQUEST,
  FETCH_FAVORITE_QUOTES_SUCCESS,
  FETCH_HIGHLIGHT_COORDINATES_FAILURE,
  FETCH_HIGHLIGHT_COORDINATES_REQUEST,
  FETCH_HIGHLIGHT_COORDINATES_SUCCESS,
  FETCH_ONBOARDING_BRANCHES_FAILURE,
  FETCH_ONBOARDING_BRANCHES_REQUEST,
  FETCH_ONBOARDING_BRANCHES_SUCCESS,
  GENERATE_QUOTE_FAIL,
  GENERATE_QUOTE_PDF_FAIL,
  GENERATE_QUOTE_PDF_REQUEST,
  GENERATE_QUOTE_PDF_RESET,
  GENERATE_QUOTE_PDF_SUCCESS,
  GENERATE_QUOTE_REQUEST,
  GENERATE_QUOTE_RESET,
  GENERATE_QUOTE_SUCCESS,
  GET_AVAILABILITIES_BY_PIDS_FAIL,
  GET_AVAILABILITIES_BY_PIDS_REQUEST,
  GET_AVAILABILITIES_BY_PIDS_SUCCESS,
  GET_DASHBOARD_QUOTES_FAILURE,
  // New API Constants
  GET_DASHBOARD_QUOTES_REQUEST,
  GET_DASHBOARD_QUOTES_SUCCESS,
  GET_EMAIL_CONVERSATION_CLEAR,
  GET_EMAIL_CONVERSATION_FAILURE,
  GET_EMAIL_CONVERSATION_LIST_FAILURE,
  GET_EMAIL_CONVERSATION_LIST_REQUEST,
  GET_EMAIL_CONVERSATION_LIST_SUCCESS,
  GET_EMAIL_CONVERSATION_REQUEST,
  GET_EMAIL_CONVERSATION_SUCCESS,
  GET_EMAIL_SIGNATURE_FAILURE,
  GET_EMAIL_SIGNATURE_REQUEST,
  GET_EMAIL_SIGNATURE_SUCCESS,
  GET_EMAIL_SUGGESTIONS_FAILURE,
  GET_EMAIL_SUGGESTIONS_REQUEST,
  GET_EMAIL_SUGGESTIONS_SUCCESS,
  GET_EMAIL_TEMPLATE_FAILURE,
  GET_EMAIL_TEMPLATE_REQUEST,
  GET_EMAIL_TEMPLATE_SUCCESS,
  GET_LAST_QUOTED_PRICE_FAIL,
  GET_LAST_QUOTED_PRICE_REQUEST,
  GET_LAST_QUOTED_PRICE_SUCCESS,
  GET_MANAGE_ALL_LINE_ITEMS_FAIL,
  GET_MANAGE_ALL_LINE_ITEMS_REQUEST,
  GET_MANAGE_ALL_LINE_ITEMS_SUCCESS,
  GET_MATCH_STATUS_FAILURE,
  GET_MATCH_STATUS_REQUEST,
  GET_MATCH_STATUS_SUCCESS,
  GET_PRICE_MARGIN_FAIL,
  GET_PRICE_MARGIN_REQUEST,
  GET_PRICE_MARGIN_SUCCESS,
  GET_QUOTE_LIST_FAIL,
  GET_QUOTE_LIST_REQUEST,
  GET_QUOTE_LIST_RESET,
  GET_QUOTE_LIST_SUCCESS,
  GET_SALESPERSON_SIGNATURE_TEMPLATE_FAILURE,
  GET_SALESPERSON_SIGNATURE_TEMPLATE_REQUEST,
  GET_SALESPERSON_SIGNATURE_TEMPLATE_SUCCESS,
  GET_SUGGESTION_FAIL,
  GET_SUGGESTION_REQUEST,
  GET_SUGGESTION_SUCCESS,
  GET_SUGGESTION_loadercomplete,
  GET_UPGRADEPRODUCTS_FAIL,
  GET_UPGRADEPRODUCTS_REQUEST,
  GET_UPGRADEPRODUCTS_SUCCESS,
  LINE_ITEM_UPDATE_DONE,
  LINE_ITEM_UPDATE_PENDING,
  LOCK_QUOTE_FAIL,
  LOCK_QUOTE_REQUEST,
  LOCK_QUOTE_SUCCESS,
  LOGIC_APP_STATUS_FAIL,
  LOGIC_APP_STATUS_REQUEST,
  LOGIC_APP_STATUS_SUCCESS,
  Lineitemsload_FAILURE,
  Lineitemsload_REQUEST,
  Lineitemsload_SUCCESS,
  MESSAGE_LIST_FAIL,
  MESSAGE_LIST_REQUEST,
  MESSAGE_LIST_SUCCESS,
  MULTI_BRANCH_AVAILABILITY_FAIL,
  MULTI_BRANCH_AVAILABILITY_REQUEST,
  MULTI_BRANCH_AVAILABILITY_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_SUCCESS_DATA_RECEIVED,
  ORDER_DETAILS_SUCCESS_STOP_LOADING,
  ORDER_LIST_DETAILS_FAIL,
  ORDER_LIST_DETAILS_REQUEST,
  ORDER_LIST_DETAILS_RESET,
  ORDER_LIST_DETAILS_SUCCESS,
  ORDER_LIST_TOTAL_DETAILS_FAIL,
  ORDER_LIST_TOTAL_DETAILS_REQUEST,
  ORDER_LIST_TOTAL_DETAILS_SUCCESS,
  ORDER_MORE_DETAILS_FAIL,
  ORDER_MORE_DETAILS_REQUEST,
  ORDER_MORE_DETAILS_SUCCESS,
  ORDER_NUMBERS_FAIL,
  ORDER_NUMBERS_GLOBAL_SEARCH_FAIL,
  ORDER_NUMBERS_GLOBAL_SEARCH_REQUEST,
  ORDER_NUMBERS_GLOBAL_SEARCH_SUCCESS,
  ORDER_NUMBERS_REQUEST,
  ORDER_NUMBERS_SUCCESS,
  ORDER_TOTAL_FAILURE,
  ORDER_TOTAL_REQUEST,
  ORDER_TOTAL_SUCCESS,
  PREVIEW_QUOTE_FAILURE,
  PREVIEW_QUOTE_REQUEST,
  PREVIEW_QUOTE_SUCCESS,
  PRICE_MARGIN_BATCH_FAIL,
  PRICE_MARGIN_BATCH_REQUEST,
  PRICE_MARGIN_BATCH_SUCCESS,
  QUICK_ORDER_LINE_ITEMS_FAIL,
  QUICK_ORDER_LINE_ITEMS_REQUEST,
  QUICK_ORDER_LINE_ITEMS_RESET,
  QUICK_ORDER_LINE_ITEMS_SUCCESS,
  QUOTE_LIST_FAIL,
  QUOTE_LIST_REQUEST,
  QUOTE_LIST_RESET,
  QUOTE_LIST_SUCCESS,
  QUOTE_NAV_DATA_FAIL,
  QUOTE_NAV_DATA_REQUEST,
  QUOTE_NAV_DATA_SUCCESS,
  QuoteInputs_FAILURE,
  QuoteInputs_REQUEST,
  QuoteInputs_SUCCESS,
  RECOMMENDATIONS_FAIL,
  RECOMMENDATIONS_REQUEST,
  RECOMMENDATIONS_RESET,
  RECOMMENDATIONS_SUCCESS,
  REFRESH_COST_FAIL,
  REFRESH_COST_REQUEST,
  REFRESH_COST_SUCCESS,
  RE_SOURCING_FAIL,
  RE_SOURCING_REQUEST,
  RE_SOURCING_RESET,
  RE_SOURCING_SUCCESS,
  SELECTED_ORDER_NUMBER_FAIL,
  SELECTED_ORDER_NUMBER_REQUEST,
  SELECTED_ORDER_NUMBER_SUCCESS,
  SELECT_DISTRIBUTOR_FAILURE,
  SELECT_DISTRIBUTOR_REQUEST,
  SELECT_DISTRIBUTOR_SUCCESS,
  SEND_DETAILED_REPLY_FAILURE,
  SEND_DETAILED_REPLY_REQUEST,
  SEND_DETAILED_REPLY_RESET,
  SEND_DETAILED_REPLY_SUCCESS,
  SEND_QUICK_REPLY_FAILURE,
  SEND_QUICK_REPLY_REQUEST,
  SEND_QUICK_REPLY_RESET,
  SEND_QUICK_REPLY_SUCCESS,
  SEND_TO_PUNCHOUT_FAIL,
  SEND_TO_PUNCHOUT_REQUEST,
  SEND_TO_PUNCHOUT_SUCCESS,
  SET_ACRONYMS_FAIL,
  SET_ACRONYMS_REQUEST,
  SET_ACRONYMS_SUCCESS,
  SHOW_DETAILS_FAIL,
  SHOW_DETAILS_REQUEST,
  SHOW_DETAILS_SUCCESS,
  SUGGESTION_FAIL,
  SUGGESTION_REQUEST,
  SUGGESTION_SUCCESS,
  TREND_GRAPH_FAIL,
  TREND_GRAPH_REQUEST,
  TREND_GRAPH_SUCCESS,
  UPDATE_EMAIL_SIGNATURE_FAILURE,
  UPDATE_EMAIL_SIGNATURE_REQUEST,
  UPDATE_EMAIL_SIGNATURE_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_FAILURE,
  UPDATE_EMAIL_TEMPLATE_REQUEST,
  UPDATE_EMAIL_TEMPLATE_SUCCESS,
  UPDATE_LINEPRICE_FAILURE,
  UPDATE_LINEPRICE_REQUEST,
  UPDATE_LINEPRICE_SUCCESS,
  UPDATE_LINE_ITEM_EXTRAS_REQUEST,
  UPDATE_LINE_ITEM_EXTRAS_RESET,
  UPDATE_LINE_ITEM_EXTRAS_SUCCESS,
  UPDATE_LINE_ITEM_NOTES_FAIL,
  UPDATE_LINE_ITEM_WIRECUT_FAILURE,
  UPDATE_LINE_ITEM_WIRECUT_REQUEST,
  UPDATE_LINE_ITEM_WIRECUT_SUCCESS,
  UPDATE_LINE_NUMBER_FAIL,
  UPDATE_LINE_NUMBER_REQUEST,
  UPDATE_LINE_NUMBER_SUCCESS,
  UPDATE_PDFKEYVALUE_FAIL,
  UPDATE_PDFKEYVALUE_REQUEST,
  UPDATE_PDFKEYVALUE_SUCCESS,
  UPDATE_PRICEMARGIN_FAILURE,
  UPDATE_PRICEMARGIN_REQUEST,
  UPDATE_PRICEMARGIN_SUCCESS,
  UPDATE_PRICE_AFTER_UOM_FAIL,
  UPDATE_PRICE_AFTER_UOM_REQUEST,
  UPDATE_PRICE_AFTER_UOM_SUCCESS,
  UPDATE_PRICE_OF_LINE_FAIL,
  UPDATE_PRICE_OF_LINE_REQUEST,
  UPDATE_PRICE_OF_LINE_SUCCESS,
  UPDATE_PRODUCT_OF_LINE_FAIL,
  UPDATE_PRODUCT_OF_LINE_REQUEST,
  UPDATE_PRODUCT_OF_LINE_SUCCESS,
  UPDATE_QUANTITY_OF_LINE_FAIL,
  UPDATE_QUANTITY_OF_LINE_REQUEST,
  UPDATE_QUANTITY_OF_LINE_SUCCESS,
  UPDATE_QUOTE_NOTES_FAIL,
  UPDATE_QUOTE_NOTES_REQUEST,
  UPDATE_QUOTE_NOTES_SUCCESS,
  UPDATE_RECOMMENDATIONS_FAIL,
  UPDATE_RECOMMENDATIONS_REQUEST,
  UPDATE_RECOMMENDATIONS_SUCCESS,
  UPDATE_SHIP_TO_ADDRESS_FAIL,
  UPDATE_SHIP_TO_ADDRESS_REQUEST,
  UPDATE_SHIP_TO_ADDRESS_RESET,
  UPDATE_SHIP_TO_ADDRESS_SUCCESS,
  UPDATE_SUPPLIER_FAIL,
  UPDATE_SUPPLIER_REQUEST,
  UPDATE_SUPPLIER_SUCCESS,
  UPDATE_TRANSACTION_TYPE_NEW_FAILURE,
  UPDATE_TRANSACTION_TYPE_NEW_REQUEST,
  UPDATE_TRANSACTION_TYPE_NEW_SUCCESS,
  UPDATE_USER_BRANCH_AVAILABILITY_FAIL,
  UPDATE_USER_BRANCH_AVAILABILITY_REQUEST,
  UPDATE_USER_BRANCH_AVAILABILITY_SUCCESS
} from '@/constants/orderConstants'
import { normalizeOrderDetailsCountries, normalizeShipToResponse } from '@/utilities/country-normaliser'

const normalizeQuoteNo = (value) => (typeof value === 'string' ? value.trim().toUpperCase() : null)

const getOrderDetailsQuoteNo = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return null
  }

  return normalizeQuoteNo(payload.quote_no || payload.order_number || payload?.header?.quote_no)
}

const getActionQuoteNo = (action) => normalizeQuoteNo(action?.meta?.quoteNo) || getOrderDetailsQuoteNo(action?.payload)

const shouldIgnoreOrderDetailsAction = (state, action) => {
  const activeQuoteNo = normalizeQuoteNo(state.activeQuoteNo)
  const actionQuoteNo = getActionQuoteNo(action)

  if (!activeQuoteNo || !actionQuoteNo) {
    return false
  }

  return activeQuoteNo !== actionQuoteNo
}

export const orderDetailsReducer = (state = { loading: true, orderDetails: {}, activeQuoteNo: null }, action) => {
  switch (action.type) {
    case ORDER_DETAILS_REQUEST: {
      const nextQuoteNo = getActionQuoteNo(action)

      return {
        ...state,
        loading: true,
        error: undefined,
        orderDetails: {},
        status: 'loading',
        activeQuoteNo: nextQuoteNo || state.activeQuoteNo
      }
    }
    case ORDER_DETAILS_SUCCESS:
      if (shouldIgnoreOrderDetailsAction(state, action)) return state

      return {
        ...state,
        loading: false,
        orderDetails: normalizeOrderDetailsCountries(action.payload),
        status: 'data_received',
        activeQuoteNo: getActionQuoteNo(action) || state.activeQuoteNo
      }
    case ORDER_DETAILS_SUCCESS_DATA_RECEIVED:
      if (shouldIgnoreOrderDetailsAction(state, action)) return state

      return {
        ...state,
        orderDetails: normalizeOrderDetailsCountries(action.payload),
        activeQuoteNo: getActionQuoteNo(action) || state.activeQuoteNo
      }
    case ORDER_DETAILS_SUCCESS_STOP_LOADING:
      if (shouldIgnoreOrderDetailsAction(state, action)) return state

      return { ...state, loading: false }
    case ORDER_DETAILS_FAIL:
      if (shouldIgnoreOrderDetailsAction(state, action)) return state

      return { ...state, loading: false, error: action.payload, orderDetails: {} }
    default:
      return state
  }
}

export const updatepricereducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case UPDATE_PRICEMARGIN_REQUEST:
      return { loading: true }
    case UPDATE_PRICEMARGIN_SUCCESS:
      return { loading: false }
    case UPDATE_PRICEMARGIN_FAILURE:
      return { loading: false }
    default:
      return state
  }
}

// Stores the last pricing field change so Quote.jsx can mirror it into the errored-items gridRows.
// Any pricing action dispatches { type: 'ERRORED_LINE_ITEM_PATCH', payload: { line_id, rowPatch, pricingPatch } }.
export const erroredLineItemPatchReducer = (state = null, action) => {
  switch (action.type) {
    case 'ERRORED_LINE_ITEM_PATCH':
      return action.payload
    default:
      return state
  }
}

export const lineItemsasyncreducer = (state = { loading: false, lineitemsresponse: [] }, action) => {
  switch (action.type) {
    case Lineitemsload_REQUEST:
      return { loading: true, lineitemsresponse: [] }
    case Lineitemsload_SUCCESS:
      return { loading: false, lineitemsresponse: action.payload }
    case Lineitemsload_FAILURE:
      return { loading: false, lineitemsresponse: [] }
    default:
      return state
  }
}

export const updateLineItemExtrasReducer = (state = { loading: false, success: false }, action) => {
  switch (action.type) {
    case UPDATE_LINE_ITEM_EXTRAS_REQUEST:
      return { loading: true, success: false }
    case UPDATE_LINE_ITEM_EXTRAS_SUCCESS:
      return { loading: false, success: true, data: action.payload }
    case UPDATE_LINE_ITEM_NOTES_FAIL:
      return { loading: false, success: false, error: action.payload }
    case UPDATE_LINE_ITEM_EXTRAS_RESET:
      return { loading: false, success: false }
    default:
      return state
  }
}

export const QuoteInputsReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case QuoteInputs_REQUEST:
      return { loading: true }
    case QuoteInputs_SUCCESS:
      return { loading: false, lineitemsresponse: action.payload }
    case QuoteInputs_FAILURE:
      return { loading: false }
    default:
      return state
  }
}

export const existingOrderDetailsReducer = (state = { loading: true, orderDetails: {}, error: false }, action) => {
  switch (action.type) {
    case EXISTING_ORDER_DETAILS_REQUEST:
      return { loading: true, orderDetails: {} }
    case EXISTING_ORDER_DETAILS_SUCCESS:
      return {
        loading: false,
        orderDetails: action.payload,
        error: false
      }
    case EXISTING_ORDER_DETAILS_FAIL:
      return { loading: false, error: action.payload, orderDetails: {} }
    default:
      return state
  }
}

export const orderNumbersReducer = (state = { orderNumbers: [] }, action) => {
  switch (action.type) {
    case ORDER_NUMBERS_REQUEST:
      return {
        loading: true,
        orderNumbers: [],
        isFirstLoading: action.payload.isFirstLoading
      }
    case ORDER_NUMBERS_SUCCESS:
      return {
        loading: false,
        orderNumbers: action.payload.data,
        isFirstLoading: action.payload.isFirstLoading
      }
    case ORDER_NUMBERS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const selectOrderNumberReducer = (state = { selectedOrderNumber: '' }, action) => {
  switch (action.type) {
    case SELECTED_ORDER_NUMBER_REQUEST:
      return { loading: true, selectedOrderNumber: '' }
    case SELECTED_ORDER_NUMBER_SUCCESS:
      return {
        loading: false,
        selectedOrderNumber: action.payload
      }
    case SELECTED_ORDER_NUMBER_FAIL:
      return { loading: false, selectedOrderNumber: '', error: action.payload }
    default:
      return state
  }
}

export const updateQuantityOfLineReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case UPDATE_QUANTITY_OF_LINE_REQUEST:
      return { loading: true, updated: {} }
    case UPDATE_QUANTITY_OF_LINE_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case UPDATE_QUANTITY_OF_LINE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const updatePriceOfLineReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case UPDATE_PRICE_OF_LINE_REQUEST:
      return { loading: true, updated: {} }
    case UPDATE_PRICE_OF_LINE_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case UPDATE_PRICE_OF_LINE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const updateProductOfLineReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_OF_LINE_REQUEST:
      return { loading: true, updated: {} }
    case UPDATE_PRODUCT_OF_LINE_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case UPDATE_PRODUCT_OF_LINE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const updateRecommendationsOfLineReducer = (state = { updated: false, error: false }, action) => {
  switch (action.type) {
    case UPDATE_RECOMMENDATIONS_REQUEST:
      return { loading: true, updated: {} }
    case UPDATE_RECOMMENDATIONS_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case UPDATE_RECOMMENDATIONS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const getSuggestionsListReducer = (state = { suggestionList: [] }, action) => {
  switch (action.type) {
    case SUGGESTION_REQUEST:
      return { ...state, loading: true }
    case SUGGESTION_SUCCESS:
      return {
        ...state,
        suggestionList: action.payload,
        loading: false,
        status: action.status
      }
    case SUGGESTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        suggestionList: []
      }
    default:
      return state
  }
}

const mergeRecommendationLists = (existing = [], incoming = []) => {
  if (!Array.isArray(existing) || !existing.length) return Array.isArray(incoming) ? incoming : []
  if (!Array.isArray(incoming) || !incoming.length) return existing

  const merged = [...existing]
  const indexByKey = new Map()

  merged.forEach((item, index) => {
    const key = item?.revpid || item?.pid
    if (key) indexByKey.set(String(key), index)
  })

  incoming.forEach((item) => {
    const key = item?.revpid || item?.pid

    if (key && indexByKey.has(String(key))) {
      merged[indexByKey.get(String(key))] = item
      return
    }

    merged.push(item)
    if (key) indexByKey.set(String(key), merged.length - 1)
  })

  return merged
}

export const getRecommendationsReducer = (state = { recommendationsList: [] }, action) => {
  switch (action.type) {
    case RECOMMENDATIONS_REQUEST:
      return action.append
        ? {
            ...state,
            loading: false,
            loadingMore: true,
            isHydrating: true,
            id: action.id,
            sessionKey: action.sessionKey ?? state.sessionKey
          }
        : {
            loading: true,
            loadingMore: false,
            isHydrating: true,
            recommendationsList: [],
            id: action.id,
            hasMore: false,
            scrollId: null,
            seenPids: [],
            sessionKey: action.sessionKey ?? null
          }
    case RECOMMENDATIONS_SUCCESS: {
      if (action.sessionKey && state.sessionKey && action.sessionKey !== state.sessionKey) return state

      const incomingPids = (action.payload || [])
        .map((item) => String(item.pid))
        // Ensure pids are strings and filter out falsy values
        .filter((pid) => pid)
      return {
        loading: false,
        loadingMore: false,
        isHydrating: typeof action.isHydrating === 'boolean' ? action.isHydrating : (state.isHydrating ?? false),
        recommendationsList: action.append ? mergeRecommendationLists(state.recommendationsList, action.payload) : action.payload,
        status: action.status,
        hasMore: typeof action.hasMore === 'boolean' ? action.hasMore : (state.hasMore ?? false),
        scrollId: typeof action.scrollId === 'string' ? action.scrollId : action.scrollId === null ? null : (state.scrollId ?? null),
        seenPids: action.append ? [...(state.seenPids ?? []), ...incomingPids] : incomingPids,
        sessionKey: action.sessionKey ?? state.sessionKey
      }
    }
    case RECOMMENDATIONS_FAIL:
      if (action.sessionKey && state.sessionKey && action.sessionKey !== state.sessionKey) return state

      return action.append
        ? { ...state, loading: false, loadingMore: false, isHydrating: false, error: action.payload }
        : { loading: false, loadingMore: false, isHydrating: false, error: action.payload, recommendationsList: [], seenPids: [] }
    case RECOMMENDATIONS_RESET:
      return {
        loading: false,
        loadingMore: false,
        isHydrating: false,
        recommendationsList: [],
        hasMore: false,
        scrollId: null,
        seenPids: [],
        sessionKey: null
      }
    default:
      return state
  }
}

export const updateFeedbackOfLineReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case UPDATE_RECOMMENDATIONS_REQUEST:
      return { loading: true, updated: {} }
    case UPDATE_RECOMMENDATIONS_SUCCESS:
      return {
        loading: false,
        updated: action?.payload
      }
    case UPDATE_RECOMMENDATIONS_FAIL:
      return { loading: false, error: action?.payload }
    default:
      return state
  }
}

export const approveOrderReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case APPROVE_ORDER_REQUEST:
      return { loading: true, updated: {} }
    case APPROVE_ORDER_SUCCESS:
      return {
        loading: false,
        updated: action?.payload
      }
    case APPROVE_ORDER_FAIL:
      return { loading: false, error: action?.payload }
    case APPROVE_ORDER_RESET:
      return { updated: {} }
    default:
      return state
  }
}

export const deleteLinesReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case DELETE_LINES_REQUEST:
      return { loading: true, updated: {} }
    case DELETE_LINES_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case DELETE_LINES_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const deleteOrderReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case DELETE_ORDER_REQUEST:
      return { loading: true, updated: {} }
    case DELETE_ORDER_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case DELETE_ORDER_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const addLineItemsFromUploadReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case ADD_LINE_ITEMS_FROM_UPLOAD_REQUEST:
      return { loading: true, updated: {} }
    case ADD_LINE_ITEMS_FROM_UPLOAD_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case ADD_LINE_ITEMS_FROM_UPLOAD_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const updateShipToAddressReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case UPDATE_SHIP_TO_ADDRESS_REQUEST:
      return { loading: true, updated: {} }
    case UPDATE_SHIP_TO_ADDRESS_SUCCESS:
      return {
        loading: false,
        updated: normalizeShipToResponse(action.payload)
      }
    case UPDATE_SHIP_TO_ADDRESS_RESET:
      return {
        loading: false,
        updated: {}
      }
    case UPDATE_SHIP_TO_ADDRESS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const updateQouteMoreDetailsReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case ORDER_MORE_DETAILS_REQUEST:
      return { loading: true, updated: {} }
    case ORDER_MORE_DETAILS_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case ORDER_MORE_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const getAttachmentFilesReducer = (state = { attachmentFiles: [] }, action) => {
  switch (action.type) {
    case ATTACHMENT_FILES_URL_REQUEST:
      return { loading: true, attachmentFiles: [] }
    case ATTACHMENT_FILES_URL_SUCCESS:
      return {
        loading: false,
        attachmentFiles: action.payload,
        status: true
      }
    case ATTACHMENT_FILES_URL_FAIL:
      return { loading: false, error: action.error, attachmentFiles: [] }
    default:
      return state
  }
}

export const getOrderListTotalDetailsReducer = (state = { totals: {} }, action) => {
  switch (action.type) {
    case ORDER_LIST_TOTAL_DETAILS_REQUEST:
      return { loading: true, totals: {} }
    case ORDER_LIST_TOTAL_DETAILS_SUCCESS:
      return {
        loading: false,
        totals: action.payload.data,
        status: true
      }
    case ORDER_LIST_TOTAL_DETAILS_FAIL:
      return { loading: false, error: action.error, totals: {} }
    default:
      return state
  }
}

export const getQuoteTableReducer = (state = { loading: false, quoteListData: {}, error: null }, action) => {
  switch (action.type) {
    case QUOTE_LIST_REQUEST:
      return { ...state, loading: true }
    case QUOTE_LIST_SUCCESS:
      return { ...state, quoteListData: action.payload, loading: false }
    case QUOTE_LIST_FAIL:
      return { ...state, loading: false, error: action.payload }
    case QUOTE_LIST_RESET:
      return { loading: false, quoteListData: {}, error: null }
    default:
      return state
  }
}

export const trendGraphReducer = (state = { loading: false, trendGraphData: {}, error: null }, action) => {
  switch (action.type) {
    case TREND_GRAPH_REQUEST:
      return { ...state, loading: true }
    case TREND_GRAPH_SUCCESS:
      return { ...state, trendGraphData: action.payload }
    case TREND_GRAPH_FAIL:
      return { ...state, error: action.payload }
    default:
      return state
  }
}

export const getOrderListReducer = (state = { orderList: {}, status: false }, action) => {
  switch (action.type) {
    case ORDER_LIST_DETAILS_REQUEST:
      return {
        loading: true,
        orderList: {
          ...state.orderList,
          search_result: []
        },
        currentSort: action.currentSort,
        _sortDataCatch: action._sortDataCatch,
        _filterDataCatch: action._filterDataCatch,
        status: false
      }
    case ORDER_LIST_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        orderList: {
          ...state.orderList,
          pit: action.payload.data?.pit,
          search_after: action.payload.data?.search_after,
          facets: action.payload.data?.facets,
          total_docs: action.payload.data?.total_docs,
          search_result: action.payload.data?.search_result ? state.orderList?.search_result?.concat(action.payload.data.search_result) : []
        },
        _sortDataCatch: action._sortDataCatch,
        _filterDataCatch: action._filterDataCatch,
        status: true
      }
    case ORDER_LIST_DETAILS_FAIL:
      return {
        loading: false,
        error: action.error,
        status: false,
        orderList: {}
      }
    case ORDER_LIST_DETAILS_RESET:
      return {
        orderList: {},
        status: false,
        loading: false
      }
    default:
      return state
  }
}

export const getQuoteListReducer = (state = { orderList: {}, status: false }, action) => {
  switch (action.type) {
    case GET_QUOTE_LIST_REQUEST:
      return {
        loading: true,
        status: false,
        orderList: {},
        _filterDataCatch: action._filterDataCatch,
        _searchQuery: action._searchQuery
      }
    case GET_QUOTE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        status: true,
        orderList: action.payload,
        _filterDataCatch: action._filterDataCatch,
        _searchQuery: action._searchQuery
      }
    case GET_QUOTE_LIST_FAIL:
      return {
        loading: false,
        status: false,
        error: action.error,
        orderList: {}
      }
    case GET_QUOTE_LIST_RESET:
      return {
        loading: false,
        status: false,
        orderList: {}
      }
    default:
      return state
  }
}

export const getNextAndPreviousQuotesReducer = (state = { loading: false, quoteNavData: {}, error: null }, action) => {
  switch (action.type) {
    case QUOTE_NAV_DATA_REQUEST:
      return { ...state, loading: true }
    case QUOTE_NAV_DATA_SUCCESS:
      return { ...state, loading: false, quoteNavData: action.payload }
    case QUOTE_NAV_DATA_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const getOrderNumberListGlobalReducer = (state = { numberList: [], status: false }, action) => {
  switch (action.type) {
    case ORDER_NUMBERS_GLOBAL_SEARCH_REQUEST:
      return {
        loading: true,
        numberList: [],
        status: false
      }
    case ORDER_NUMBERS_GLOBAL_SEARCH_SUCCESS:
      return {
        loading: false,
        numberList: action.payload,
        status: true
      }
    case ORDER_NUMBERS_GLOBAL_SEARCH_FAIL:
      return {
        loading: false,
        error: action.error,
        status: false,
        numberList: []
      }
    default:
      return state
  }
}

export const getCustomerDetailsListReducer = (state = { numberList: [], status: false }, action) => {
  switch (action.type) {
    case CUSTOMER_DETAILS_LIST_REQUEST:
      return {
        loading: true,
        numberList: [],
        status: false
      }
    case CUSTOMER_DETAILS_LIST_SUCCESS:
      return {
        loading: false,
        numberList: action.payload.data,
        status: true
      }
    case CUSTOMER_DETAILS_LIST_FAIL:
      return {
        loading: false,
        // error: action.error,
        status: false,
        numberList: []
      }
    case CUSTOMER_DETAILS_LIST_RESET:
      return {
        loading: false,
        status: false,
        numberList: []
      }
    default:
      return state
  }
}

export const createQuoteReducer = (state = { createdQoute: {}, status: false }, action) => {
  switch (action.type) {
    case CREATE_QUOTE_REQUEST:
      return {
        loading: true,
        createdQoute: {},
        status: false
      }
    case CREATE_QUOTE_SUCCESS:
      return {
        loading: false,
        createdQoute: action.payload.data,
        status: true
      }
    case CREATE_QUOTE_FAIL:
      return {
        loading: false,
        error: action.payload,
        status: false,
        createdQoute: {}
      }
    case CREATE_QUOTE_RESET:
      return { createdQoute: {}, status: false, loading: false }
    default:
      return state
  }
}

export const showDetailsReducer = (state = { shownDetails: {}, status: false }, action) => {
  switch (action.type) {
    case SHOW_DETAILS_REQUEST:
      return {
        loading: true,
        shownDetails: {},
        status: false
      }
    case SHOW_DETAILS_SUCCESS:
      return {
        loading: false,
        shownDetails: action.payload.data,
        status: true
      }
    case SHOW_DETAILS_FAIL:
      return {
        loading: false,
        error: action.error,
        status: false,
        shownDetails: {}
      }
    default:
      return state
  }
}

export const updateLineNumberReducer = (state = { data: {}, status: false }, action) => {
  switch (action.type) {
    case UPDATE_LINE_NUMBER_REQUEST:
      return {
        loading: true,
        data: {},
        status: false
      }
    case UPDATE_LINE_NUMBER_SUCCESS:
      return {
        loading: false,
        data: action.payload.data,
        status: true
      }
    case UPDATE_LINE_NUMBER_FAIL:
      return {
        loading: false,
        error: action.error,
        status: false,
        data: {}
      }
    default:
      return state
  }
}

// Khizer
export const addAcronymsReducer = (state = { added: {} }, action) => {
  switch (action.type) {
    case SET_ACRONYMS_REQUEST:
      return { loading: true, added: {} }
    case SET_ACRONYMS_SUCCESS:
      return {
        loading: false,
        added: action.payload
      }
    case SET_ACRONYMS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const updateSupplierReducer = (state = { data: {}, status: false }, action) => {
  switch (action.type) {
    case UPDATE_SUPPLIER_REQUEST:
      return {
        loading: true,
        data: {},
        status: false
      }
    case UPDATE_SUPPLIER_SUCCESS:
      return {
        loading: false,
        data: action.payload.data,
        status: true
      }
    case UPDATE_SUPPLIER_FAIL:
      return {
        loading: false,
        error: action.error,
        status: false,
        data: {}
      }
    default:
      return state
  }
}
export const updatePDFKeyValueReducer = (state = { data: {}, status: false }, action) => {
  switch (action.type) {
    case UPDATE_PDFKEYVALUE_REQUEST:
      return {
        loading: true,
        data: {},
        status: false
      }
    case UPDATE_PDFKEYVALUE_SUCCESS:
      return {
        loading: false,
        data: action.payload.data,
        status: true
      }
    case UPDATE_PDFKEYVALUE_FAIL:
      return {
        loading: false,
        error: action.error,
        status: false,
        data: {}
      }
    default:
      return state
  }
}

export const getExpandRowDetailsReducer = (state = { loading: true, data: {}, status: false }, action) => {
  switch (action.type) {
    case EXPAND_ROW_DETAILS_REQUEST:
      return { loading: true, data: {}, status: false }
    case EXPAND_ROW_DETAILS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        status: true
      }
    case EXPAND_ROW_DETAILS_FAIL:
      return { loading: false, error: action.payload, status: false }
    default:
      return state
  }
}

// new apis starts here
export const updateQuoteNotesReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case UPDATE_QUOTE_NOTES_REQUEST:
      return { loading: true, updated: {} }
    case UPDATE_QUOTE_NOTES_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case UPDATE_QUOTE_NOTES_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const getAvailabilitiesByPidsReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case GET_AVAILABILITIES_BY_PIDS_REQUEST:
      return { loading: true, data: {} }
    case GET_AVAILABILITIES_BY_PIDS_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case GET_AVAILABILITIES_BY_PIDS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const quickOrderLineItemsReducer = (state = { updated: {} }, action) => {
  switch (action.type) {
    case QUICK_ORDER_LINE_ITEMS_REQUEST:
      return { loading: true, updated: {} }
    case QUICK_ORDER_LINE_ITEMS_SUCCESS:
      return {
        loading: false,
        updated: action.payload
      }
    case QUICK_ORDER_LINE_ITEMS_FAIL:
      return { loading: false, error: action.payload }
    case QUICK_ORDER_LINE_ITEMS_RESET:
      return { updated: {} }
    default:
      return state
  }
}

export const reSourcingReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case RE_SOURCING_REQUEST:
      return { loading: true, data: {} }
    case RE_SOURCING_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case RE_SOURCING_FAIL:
      return { loading: false, error: action.payload }
    case RE_SOURCING_RESET:
      return { loading: false, data: {} }
    default:
      return state
  }
}

export const UpgradesReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case GET_UPGRADEPRODUCTS_REQUEST:
      return { loading: true, data: {} }
    case GET_UPGRADEPRODUCTS_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case GET_UPGRADEPRODUCTS_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const customerShippingDetailsReducer = (state = { data: {}, status: false }, action) => {
  switch (action.type) {
    case CUSTOMER_SHIPPING_DETAILS_REQUEST:
      return { loading: true, data: {}, status: false }
    case CUSTOMER_SHIPPING_DETAILS_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        status: 'Data received'
      }
    case CUSTOMER_SHIPPING_DETAILS_FAIL:
      return { loading: false, error: action.payload, status: 'Data received' }
    default:
      return state
  }
}

export const adminUserListReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case ADMIN_USER_LIST_REQUEST:
      return { loading: true, data: {} }
    case ADMIN_USER_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case ADMIN_USER_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminUserAddReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case ADMIN_USER_ADD_REQUEST:
      return { loading: true, data: {} }
    case ADMIN_USER_ADD_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case ADMIN_USER_ADD_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminUserUpdateReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case ADMIN_USER_UPDATE_REQUEST:
      return { loading: true, data: {} }
    case ADMIN_USER_UPDATE_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case ADMIN_USER_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const adminUserDeleteReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case ADMIN_USER_DELETE_REQUEST:
      return { loading: true, data: {} }
    case ADMIN_USER_DELETE_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case ADMIN_USER_DELETE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const branchListReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case BRANCH_LIST_REQUEST:
      return { loading: true, data: {} }
    case BRANCH_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case BRANCH_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const branchAddReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case BRANCH_ADD_REQUEST:
      return { loading: true, data: {} }
    case BRANCH_ADD_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case BRANCH_ADD_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const branchUpdateReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case BRANCH_UPDATE_REQUEST:
      return { loading: true, data: {} }
    case BRANCH_UPDATE_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case BRANCH_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const branchDeleteReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case BRANCH_DELETE_REQUEST:
      return { loading: true, data: {} }
    case BRANCH_DELETE_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case BRANCH_DELETE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const distributorListReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case DISTRIBUTOR_LIST_REQUEST:
      return { loading: true, data: [] }
    case DISTRIBUTOR_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case DISTRIBUTOR_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const messageListReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case MESSAGE_LIST_REQUEST:
      return { loading: true, data: {} }
    case MESSAGE_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case MESSAGE_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const getLastQuotedPriceReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case GET_LAST_QUOTED_PRICE_REQUEST:
      return { loading: true, data: [] }
    case GET_LAST_QUOTED_PRICE_SUCCESS:
      return {
        loading: false,
        data: action.payload
      }
    case GET_LAST_QUOTED_PRICE_FAIL:
      return { loading: false, data: [], error: action.payload }
    default:
      return state
  }
}

export const bulkDeleteQuoteReducer = (state = { data: [], status: false, loading: false }, action) => {
  switch (action.type) {
    case BULK_QUOTE_DELETE_REQUEST:
      return {
        loading: true,
        status: false,
        data: []
      }
    case BULK_QUOTE_DELETE_SUCCESS:
      return {
        loading: false,
        data: action.payload.data,
        status: true
      }
    case BULK_QUOTE_DELETE_FAIL:
      return {
        loading: false,
        error: action.error,
        status: false,
        data: []
      }
    case BULK_QUOTE_RESET:
      return {
        ...state,
        status: false
      }
    default:
      return state
  }
}

export const bulkApproveQuoteReducer = (state = { data: [], approveStatus: false, loading: false }, action) => {
  switch (action.type) {
    case BULK_QUOTE_APPROVE_REQUEST:
      return {
        loading: true,
        approveStatus: false,
        data: []
      }
    case BULK_QUOTE_APPROVE_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        approveStatus: true
      }
    case BULK_QUOTE_APPROVE_FAIL:
      return {
        loading: false,
        error: action.error,
        approveStatus: false,
        data: []
      }
    case BULK_QUOTE_APPROVE_RESET:
      return {
        ...state,
        approveStatus: false
      }
    default:
      return state
  }
}

export const availablitiesreducer = (state = { data: [], approveStatus: false, loading: false, status: '' }, action) => {
  switch (action.type) {
    case AVAILABILITIES_REQUEST:
      return {
        loading: true
      }
    case AVAILABILITIES_SUCCESS:
      return {
        loading: false,
        status: 'Availablity received'
      }
    case AVAILABILITIES_FAIL:
      return {
        loading: false,
        status: 'Availablity failed'
      }
    default:
      return state
  }
}

const onboardingBranchesReducerInitialState = {
  loading: false,
  branches: [],
  error: null
}

export const onboardingBranchesReducer = (state = onboardingBranchesReducerInitialState, action) => {
  switch (action.type) {
    case FETCH_ONBOARDING_BRANCHES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FETCH_ONBOARDING_BRANCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        branches: action.payload
      }
    case FETCH_ONBOARDING_BRANCHES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state
  }
}

const distributorReducerInitialState = {
  loading: false,
  data: null,
  error: null
}

export const distributorReducer = (state = distributorReducerInitialState, action) => {
  switch (action.type) {
    case SELECT_DISTRIBUTOR_REQUEST:
      return {
        ...state,
        loading: true
      }
    case SELECT_DISTRIBUTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }
    case SELECT_DISTRIBUTOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

const lineItemWireCutReducerinitialState = {
  loading: false,
  data: null,
  error: null
}

export const lineItemWireCutReducer = (state = lineItemWireCutReducerinitialState, action) => {
  switch (action.type) {
    case UPDATE_LINE_ITEM_WIRECUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case UPDATE_LINE_ITEM_WIRECUT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }
    case UPDATE_LINE_ITEM_WIRECUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

const customerPartNumbersReducerInitialState = {
  loading: false,
  data: [],
  error: null
}

export const customerPartNumbersReducer = (state = customerPartNumbersReducerInitialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_PART_NUMBERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case FETCH_CUSTOMER_PART_NUMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      }

    case FETCH_CUSTOMER_PART_NUMBERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

const favoriteQuoteTableDataReducerinitialState = {
  loading: false,
  data: [],
  error: ''
}

export const favoriteQuoteTableDataReducer = (state = favoriteQuoteTableDataReducerinitialState, action) => {
  switch (action.type) {
    case FETCH_FAVORITE_QUOTES_REQUEST:
      return { ...state, loading: true, error: '' }

    case FETCH_FAVORITE_QUOTES_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' }

    case FETCH_FAVORITE_QUOTES_FAILURE:
      return { ...state, loading: false, error: action.payload }

    default:
      return state
  }
}

const priceMarginReducerinitialState = {
  loading: false,
  data: null,
  error: null
}

export const priceMarginReducer = (state = priceMarginReducerinitialState, action) => {
  switch (action.type) {
    case GET_PRICE_MARGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_PRICE_MARGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload
      }

    case GET_PRICE_MARGIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

const priceMarginBatchInitialState = {
  loading: false,
  priceFetchComplete: true,
  fetched: 0,
  remaining: 0,
  error: null
}

export const priceMarginBatchReducer = (state = priceMarginBatchInitialState, action) => {
  switch (action.type) {
    case PRICE_MARGIN_BATCH_REQUEST:
      return { ...state, loading: true, error: null }
    case PRICE_MARGIN_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        priceFetchComplete: action.payload.price_fetch_complete,
        fetched: action.payload.fetched,
        remaining: action.payload.remaining
      }
    case PRICE_MARGIN_BATCH_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const LinePriceReducer = (state = priceMarginReducerinitialState, action) => {
  switch (action.type) {
    case UPDATE_LINEPRICE_REQUEST:
      return {
        ...state,
        loading: true,
        data: action.data,
        error: null
      }

    case UPDATE_LINEPRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data
      }

    case UPDATE_LINEPRICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

export const linesuggestionReducer = (state = priceMarginReducerinitialState, action) => {
  switch (action.type) {
    case GET_SUGGESTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        sessionKey: action.sessionKey ?? null
      }

    case GET_SUGGESTION_SUCCESS:
      if (action.sessionKey && state.sessionKey && action.sessionKey !== state.sessionKey) return state
      return {
        ...state,
        // loading: false,
        data: action.payload,
        sessionKey: action.sessionKey ?? state.sessionKey
      }
    case GET_SUGGESTION_loadercomplete:
      if (action.sessionKey && state.sessionKey && action.sessionKey !== state.sessionKey) return state
      return {
        ...state,
        loading: false,
        data: action.payload,
        sessionKey: action.sessionKey ?? state.sessionKey
      }
    case GET_SUGGESTION_FAIL:
      if (action.sessionKey && state.sessionKey && action.sessionKey !== state.sessionKey) return state
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

const erroredLineItemsInitialState = {
  loading: false,
  data: null,
  total: 0,
  pages: 1,
  currentPage: 1,
  pageSize: 20,
  error: null
}

export const erroredLineItemsReducer = (state = erroredLineItemsInitialState, action) => {
  switch (action.type) {
    case 'GET_ERRORED_LINE_ITEMS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'GET_ERRORED_LINE_ITEMS_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.payload.items,
        total: action.payload.total,
        pages: action.payload.pages,
        currentPage: action.payload.currentPage,
        pageSize: action.payload.pageSize
      }

    case 'GET_ERRORED_LINE_ITEMS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case 'RESET_ERRORED_LINE_ITEMS':
      return erroredLineItemsInitialState

    default:
      return state
  }
}

// Dashboard Quotes Reducer
export const dashboardQuotesReducer = (state = { loading: false, quotes: [], error: null }, action) => {
  switch (action.type) {
    case GET_DASHBOARD_QUOTES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_DASHBOARD_QUOTES_SUCCESS:
      return {
        ...state,
        loading: false,
        quotes: action.payload,
        error: null
      }
    case GET_DASHBOARD_QUOTES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Transaction Type Update Reducer
export const transactionTypeUpdateReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case UPDATE_TRANSACTION_TYPE_NEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case UPDATE_TRANSACTION_TYPE_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null
      }
    case UPDATE_TRANSACTION_TYPE_NEW_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Email Conversation List Reducer
export const emailConversationListReducer = (state = { loading: false, conversations: [], error: null, total: 0 }, action) => {
  switch (action.type) {
    case GET_EMAIL_CONVERSATION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_EMAIL_CONVERSATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        conversations: action.payload.conversations || [],
        total: action.payload.total || 0,
        has_next: action.payload.has_next || false,
        has_previous: action.payload.has_previous || false,
        error: null
      }
    case GET_EMAIL_CONVERSATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CLEAR_EMAIL_CONVERSATIONS:
      return {
        loading: false,
        conversations: [],
        error: null,
        total: 0,
        has_next: false,
        has_previous: false
      }
    default:
      return state
  }
}

// Email Conversation Reducer
export const emailConversationReducer = (
  state = { loading: false, messages: [], error: null, pagination: {}, conversation_id: null },
  action
) => {
  switch (action.type) {
    case GET_EMAIL_CONVERSATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_EMAIL_CONVERSATION_SUCCESS:
      return {
        ...state,
        loading: false,
        messages: action.payload.messages || [],
        conversation_id: action.payload.conversation_id || null,
        pagination: {
          total: action.payload.total,
          page: action.payload.page,
          page_size: action.payload.page_size,
          has_next: action.payload.has_next,
          has_previous: action.payload.has_previous
        },
        error: null
      }
    case GET_EMAIL_CONVERSATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case GET_EMAIL_CONVERSATION_CLEAR:
      return {
        ...state,
        messages: [],
        conversation_id: null,
        pagination: {},
        error: null
      }
    default:
      return state
  }
}

// Quick Reply Reducer
export const quickReplyReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case SEND_QUICK_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case SEND_QUICK_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null
      }
    case SEND_QUICK_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    case SEND_QUICK_REPLY_RESET:
      return {
        loading: false,
        success: false,
        error: null
      }
    default:
      return state
  }
}

// Detailed Reply Reducer
export const detailedReplyReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case SEND_DETAILED_REPLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case SEND_DETAILED_REPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        responseData: action.payload // Store the response data including conversation_id
      }
    case SEND_DETAILED_REPLY_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    case SEND_DETAILED_REPLY_RESET:
      return {
        loading: false,
        success: false,
        error: null,
        responseData: null // Clear response data on reset
      }
    default:
      return state
  }
}

// Email Signature Reducer
export const emailSignatureReducer = (state = { loading: false, signature: '', error: null }, action) => {
  switch (action.type) {
    case GET_EMAIL_SIGNATURE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_EMAIL_SIGNATURE_SUCCESS:
      return {
        ...state,
        loading: false,
        signature: action.payload.email_signature || '',
        error: null
      }
    case GET_EMAIL_SIGNATURE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Email Suggestions Reducer
export const emailSuggestionsReducer = (state = { loading: false, suggestions: [], error: null }, action) => {
  switch (action.type) {
    case GET_EMAIL_SUGGESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_EMAIL_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        suggestions: action.payload || [],
        error: null
      }
    case GET_EMAIL_SUGGESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        suggestions: [],
        error: action.payload
      }
    default:
      return state
  }
}

// Preview Quote Reducer
export const previewQuoteReducer = (state = { loading: false, htmlContent: null, error: null }, action) => {
  switch (action.type) {
    case PREVIEW_QUOTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case PREVIEW_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        htmlContent: action.payload,
        error: null
      }
    case PREVIEW_QUOTE_FAILURE:
      return {
        ...state,
        loading: false,
        htmlContent: null,
        error: action.payload
      }
    default:
      return state
  }
}

// Update Email Signature Reducer
export const updateEmailSignatureReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case UPDATE_EMAIL_SIGNATURE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case UPDATE_EMAIL_SIGNATURE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null
      }
    case UPDATE_EMAIL_SIGNATURE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Email Template Reducer
export const emailTemplateReducer = (state = { loading: false, template: '', error: null }, action) => {
  switch (action.type) {
    case GET_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        template: action.payload.email_template || '',
        error: null
      }
    case GET_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Update Email Template Reducer
export const updateEmailTemplateReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case UPDATE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case UPDATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null
      }
    case UPDATE_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Combined Salesperson Signature and Template Reducer
export const salespersonSignatureTemplateReducer = (
  state = {
    loading: false,
    signature: '',
    template: '',
    error: null,
    data: null
  },
  action
) => {
  switch (action.type) {
    case GET_SALESPERSON_SIGNATURE_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_SALESPERSON_SIGNATURE_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        signature: action.payload.email_signature || '',
        template: action.payload.email_template || '',
        data: action.payload,
        error: null
      }
    case GET_SALESPERSON_SIGNATURE_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Generate Quote Reducer
export const generateQuoteReducer = (state = { loading: false, success: false, error: null, pdfUrl: null, generatedAt: null }, action) => {
  switch (action.type) {
    case GENERATE_QUOTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case GENERATE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        pdfUrl: action.payload.pdfUrl,
        generatedAt: action.payload.generatedAt,
        quoteNo: action.payload.quoteNo
      }
    case GENERATE_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        pdfUrl: null
      }
    case GENERATE_QUOTE_RESET:
      return {
        loading: false,
        success: false,
        error: null,
        pdfUrl: null,
        generatedAt: null,
        quoteNo: null
      }
    default:
      return state
  }
}

// Generate Quote PDF Reducer (NEW)
export const generateQuotePDFReducer = (
  state = { loading: false, success: false, error: null, attachmentId: null, name: null, contentBytes: null },
  action
) => {
  switch (action.type) {
    case GENERATE_QUOTE_PDF_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case GENERATE_QUOTE_PDF_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        attachmentId: action.payload.attachmentId,
        name: action.payload.name,
        contentBytes: action.payload.contentBytes,
        generatedAt: action.payload.generatedAt,
        quoteNo: action.payload.quoteNo
      }
    case GENERATE_QUOTE_PDF_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        attachmentId: null,
        name: null,
        contentBytes: null
      }
    case GENERATE_QUOTE_PDF_RESET:
      return {
        loading: false,
        success: false,
        error: null,
        attachmentId: null,
        name: null,
        contentBytes: null,
        generatedAt: null,
        quoteNo: null
      }
    default:
      return state
  }
}

// Send to PunchOut/WebApp Reducer
export const sendToPunchOutReducer = (
  state = {
    loading: false,
    success: false,
    error: null,
    data: null
  },
  action
) => {
  switch (action.type) {
    case SEND_TO_PUNCHOUT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case SEND_TO_PUNCHOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        data: action.payload
      }
    case SEND_TO_PUNCHOUT_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Refresh Cost Reducer
export const refreshCostReducer = (state = { loading: false, success: false, error: null, data: null }, action) => {
  switch (action.type) {
    case REFRESH_COST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case REFRESH_COST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        data: action.payload
      }
    case REFRESH_COST_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    default:
      return state
  }
}

// Create Quotation Reducer (NEW)
export const createQuotationReducer = (state = { loading: false, success: false, error: null, data: null }, action) => {
  switch (action.type) {
    case CREATE_QUOTATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case CREATE_QUOTATION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        data: action.payload.data,
        attachmentId: action.payload.attachmentId,
        quoteNo: action.payload.quoteNo,
        createdAt: action.payload.createdAt
      }
    case CREATE_QUOTATION_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        data: null
      }
    case CREATE_QUOTATION_RESET:
      return {
        loading: false,
        success: false,
        error: null,
        data: null,
        attachmentId: null,
        quoteNo: null,
        createdAt: null
      }
    default:
      return state
  }
}

// Lock Quote Reducer
export const lockQuoteReducer = (state = { loading: false, success: false, error: null, lockedAt: null, isLocked: false }, action) => {
  switch (action.type) {
    case LOCK_QUOTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      }
    case LOCK_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        lockedAt: action.payload.lockedAt,
        quoteNo: action.payload.quoteNo,
        isLocked: action.payload.isLocked
      }
    case LOCK_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      }
    default:
      return state
  }
}

const matchStatusReducerinitialState = {
  loading: false,
  data: [],
  error: null
}

export const matchStatusReducer = (state = matchStatusReducerinitialState, action) => {
  switch (action.type) {
    case GET_MATCH_STATUS_REQUEST:
      return { ...state, loading: true, error: null }

    case GET_MATCH_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload }

    case GET_MATCH_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload }

    default:
      return state
  }
}

const logicAppStatusReducerinitialState = {
  loading: false,
  data: [],
  error: null
}

export const logicAppStatusReducer = (state = logicAppStatusReducerinitialState, action) => {
  switch (action.type) {
    case LOGIC_APP_STATUS_REQUEST:
      return { loading: true, status: null }
    case LOGIC_APP_STATUS_SUCCESS:
      return { loading: false, data: action.payload }
    case LOGIC_APP_STATUS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

// Update User Branch Availability Reducer
const updateUserBranchAvailabilityInitialState = {
  loading: false,
  data: null,
  error: null
}

export const updateUserBranchAvailabilityReducer = (state = updateUserBranchAvailabilityInitialState, action) => {
  switch (action.type) {
    case UPDATE_USER_BRANCH_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null }
    case UPDATE_USER_BRANCH_AVAILABILITY_SUCCESS:
      return { loading: false, data: action.payload, error: null }
    case UPDATE_USER_BRANCH_AVAILABILITY_FAIL:
      return { loading: false, data: null, error: action.payload }
    default:
      return state
  }
}

// Clear User Branch Availability Reducer
const clearUserBranchAvailabilityInitialState = {
  loading: false,
  data: null,
  error: null
}

export const clearUserBranchAvailabilityReducer = (state = clearUserBranchAvailabilityInitialState, action) => {
  switch (action.type) {
    case CLEAR_USER_BRANCH_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null }
    case CLEAR_USER_BRANCH_AVAILABILITY_SUCCESS:
      return { loading: false, data: action.payload, error: null }
    case CLEAR_USER_BRANCH_AVAILABILITY_FAIL:
      return { loading: false, data: null, error: action.payload }
    default:
      return state
  }
}

// Initial State
const lineItemCoordinatesInitialState = {
  coordinates: null,
  loading: false,
  error: null
}

// Line Item coordinates Reducer
export const lineItemHighlightCoordinatesReducer = (state = lineItemCoordinatesInitialState, action) => {
  switch (action.type) {
    case FETCH_HIGHLIGHT_COORDINATES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FETCH_HIGHLIGHT_COORDINATES_SUCCESS:
      return {
        ...state,
        loading: false,
        coordinates: action.payload,
        error: null
      }
    case FETCH_HIGHLIGHT_COORDINATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CLEAR_HIGHLIGHT_COORDINATES:
      return lineItemCoordinatesInitialState
    default:
      return state
  }
}

// Manage All Line Items Reducer
const manageAllLineItemsInitialState = {
  loading: false,
  ManageAllLineItems: [],
  error: null
}

export const manageAllLineItemsReducer = (state = manageAllLineItemsInitialState, action) => {
  switch (action.type) {
    case GET_MANAGE_ALL_LINE_ITEMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_MANAGE_ALL_LINE_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        ManageAllLineItems: action.payload,
        error: null
      }
    case GET_MANAGE_ALL_LINE_ITEMS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

const totalOrderReducerinitialState = {
  loading: false,
  error: null
}

export const totalOrderReducer = (state = totalOrderReducerinitialState, action) => {
  switch (action.type) {
    case ORDER_TOTAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case ORDER_TOTAL_SUCCESS:
      return {
        ...state,
        loading: false
      }

    case ORDER_TOTAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}
export const multiBranchAvailabilityReducer = (state = { loading: false, data: {}, error: null }, action) => {
  switch (action.type) {
    case MULTI_BRANCH_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null }
    case MULTI_BRANCH_AVAILABILITY_SUCCESS:
      return { loading: false, data: { ...state.data, ...action.payload }, error: null }
    case MULTI_BRANCH_AVAILABILITY_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export const updatePriceAfterUomReducer = (state = { loading: false, data: null }, action) => {
  switch (action.type) {
    case UPDATE_PRICE_AFTER_UOM_REQUEST:
      return { loading: true, data: null }
    case UPDATE_PRICE_AFTER_UOM_SUCCESS:
      return { loading: false, data: action.payload }
    case UPDATE_PRICE_AFTER_UOM_FAIL:
      return { loading: false, error: true }
    default:
      return state
  }
}

export const lineItemUpdatePendingReducer = (state = { pending: false }, action) => {
  switch (action.type) {
    case LINE_ITEM_UPDATE_PENDING:
      return { pending: true }
    case LINE_ITEM_UPDATE_DONE:
      return { pending: false }
    default:
      return state
  }
}
